import { Link, useLocation } from 'react-router-dom';

interface Crumb {
  label: string;
  path?: string;
}

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  const crumbs: Crumb[] = [{ label: '首页', path: '/' }];

  if (pathSegments[0] === 'category' && pathSegments[1]) {
    crumbs.push({ label: '分类浏览', path: undefined });
    const catName = getCategoryName(pathSegments[1]);
    crumbs.push({ label: catName, path: location.pathname });
  } else if (pathSegments[0] === 'article' && pathSegments[1]) {
    crumbs.push({ label: '文章详情', path: undefined });
    crumbs.push({ label: '阅读中...', path: location.pathname });
  } else if (pathSegments[0] === 'about') {
    crumbs.push({ label: '关于我们', path: '/about' });
  }

  if (crumbs.length <= 1) return null;

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: crumbs.map((crumb, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      item: crumb.path
        ? {
            '@id': `https://yoshizawa-fans.com${crumb.path}`,
            name: crumb.label,
          }
        : undefined,
      ...(crumb.path ? {} : { name: crumb.label }),
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-0">
        <ol className="flex items-center gap-1.5 text-xs text-foreground-500 flex-wrap">
          {crumbs.map((crumb, i) => (
            <li key={i} className="flex items-center gap-1.5">
              {i > 0 && <i className="ri-arrow-right-s-line text-xs"></i>}
              {crumb.path ? (
                <Link
                  to={crumb.path}
                  className="hover:text-primary-600 transition-colors"
                >
                  {crumb.label}
                </Link>
              ) : (
                <span className="text-foreground-400">{crumb.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}

function getCategoryName(slug: string): string {
  const map: Record<string, string> = {
    personal: '个人资料',
    career: '演艺经历',
    works: '代表作品',
    news: '最新动态',
    community: '粉丝社区',
  };
  return map[slug] || slug;
}